module.exports = __webpack_public_path__ + "media/images/iconLockClosed__errorRed-9f89d37b55dde16e5f73e21fe8f0d6c2.png";